
// import {Injectable} from '@angular/core';
// import { Router } from '@angular/router';

// @Injectable()
// export class PageNavigationService {

//     vCurrentPage: string;
//     vListParams: any;
//     vPrevPage: string;
//     vCode:string;
//     vParam:string; 

//     constructor(private _router: Router) {
//         this.vListParams = [];
//         this.vCurrentPage = '';
//         this.vPrevPage = '';
//         this.vCode='';
//         this.vParam='';
//     }

//     getCurrentParams() {
//         if (this.vListParams.length > 0) {
//             return this.peekParam().param;
//         } else return null;
//     }

//     getCurrentPage() {
//         return this.vCurrentPage;
//     }

//     setCurrentPage(pCurrentPage: string, pParam?: any) {
//         if(pCurrentPage === 'home') {
//             this.resetNavigation();
//         }

//         this.vCurrentPage = pCurrentPage;
        
//         if (this.vListParams.length === 0) { // if stack is still null
//             // push new stack of page of current page
//             this.pushParam(this.vCurrentPage, pParam, this.vPrevPage);
//             this.setPreviousPage(this.peekParam().page);
//         } else if(this.peekParam().page !== this.vCurrentPage) { // do not pop or push same page
//             let hitBackButton = false;

//             for(let g=this.vListParams.length-1; g>=0; g--) {
//                 if(this.vListParams[g].page === this.vCurrentPage) { // if stack has current page, means user hit back button
//                     hitBackButton = true;
//                     for(let m=this.vListParams.length-1; m>g; m--) {
//                         this.popParam();
//                     }

//                     if(this.vListParams.length >= 2)
//                         this.setPreviousPage(this.vListParams[this.vListParams.length - 2].page);
//                     else
//                         this.setPreviousPage('');

//                     break;
//                 }
//             }

//             if(!hitBackButton) {
//                 this.setPreviousPage(this.peekParam().page);
//                 this.pushParam(this.vCurrentPage, pParam, this.vPrevPage);
//             }
//         }
//     }

//     getPreviousPage() {
//         return this.vPrevPage;
//     }

//     setPreviousPage(pPrevPage: string) {
//         this.vPrevPage = pPrevPage;
//     }

//     resetNavigation() {
//         this.vCurrentPage = '';
//         this.vPrevPage = '';
//         this.vListParams = [];
//     }

//     pushParam(pPage: string, pParam: any, pPrevious: string) {
//         let vData = {
//             page: pPage,
//             param: pParam,
//             previous: pPrevious
//         };
//         this.vListParams.push(vData);
//     }

//     peekParam() {
//         if (this.vListParams !== null && this.vListParams.length !== 0) {
//             return this.vListParams[this.vListParams.length - 1];
//         }
//         else return null;
//     }

//     popParam() {
//         if (this.vListParams.length > 0) {
//             this.vListParams.pop();
//         }
//     }

//     gotoPreviousPage() {
//         this.navigate([this.getPreviousPage()]);       
//     }

//     getUrlParameter(name, url) {
//         name = name.replace(/[\[\]]/g, '\\$&');
//         var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),results = regex.exec(url);
//         if (!results) 
//             return null;
//         if (!results[2]) 
//             return '';
//         return decodeURIComponent(results[2].replace(/\+/g, ' '));
//     }

//     navigate(pPage: any) {
//         this.vParam = this.getUrlParameter('error',window.location.href);
//         if(this.vParam === 'access_denied') {
//             // window.location.href = 'http://new.digi.com.my/home';
//             this._router.navigate('/home');    
//         }
//         else {
//             this._router.navigate(pPage);
//             this.vCode = this.getUrlParameter('code',window.location.href); 
//         }
//     }

//     getListParams() {
//         return this.vListParams;
//     }

// }


import {Injectable} from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class PageNavigationService {
    
    vCurrentPage: string;
    vListParams: any;
    vPrevPage: string;
    vCode:string;
    vParam:string; 

    constructor(private _router: Router) {
        this.vListParams = [];
        this.vCurrentPage = '';
        this.vPrevPage = '';
        this.vCode='';
        this.vParam='';
    }

    getCurrentParams() {
        if (this.vListParams.length > 0) {
            return this.peekParam().param;
        } else return null;
    }

    getCurrentPage() {
        return this.vCurrentPage;
    }

    setCurrentPage(pCurrentPage: string, pParam?: any) {
        if(pCurrentPage === 'home') {
            this.resetNavigation();
        }

        this.vCurrentPage = pCurrentPage;
        
        if (this.vListParams.length === 0) { // if stack is still null
            // push new stack of page of current page
            this.pushParam(this.vCurrentPage, pParam, this.vPrevPage);
            this.setPreviousPage(this.peekParam().page);
        } else if(this.peekParam().page !== this.vCurrentPage) { // do not pop or push same page
            let hitBackButton = false;

            for(let g=this.vListParams.length-1; g>=0; g--) {
                if(this.vListParams[g].page === this.vCurrentPage) { // if stack has current page, means user hit back button
                    hitBackButton = true;
                    for(let m=this.vListParams.length-1; m>g; m--) {
                        this.popParam();
                    }

                    if(this.vListParams.length >= 2)
                        this.setPreviousPage(this.vListParams[this.vListParams.length - 2].page);
                    else
                        this.setPreviousPage('');

                    break;
                }
            }

            if(!hitBackButton) {
                this.setPreviousPage(this.peekParam().page);
                this.pushParam(this.vCurrentPage, pParam, this.vPrevPage);
            }
        }
    }

    getPreviousPage() {
        return this.vPrevPage;
    }

    setPreviousPage(pPrevPage: string) {
        this.vPrevPage = pPrevPage;
    }

    resetNavigation() {
        this.vCurrentPage = '';
        this.vPrevPage = '';
        this.vListParams = [];
    }

    pushParam(pPage: string, pParam: any, pPrevious: string) {
        let vData = {
            page: pPage,
            param: pParam,
            previous: pPrevious
        };
        this.vListParams.push(vData);
    }

    peekParam() {
        if (this.vListParams !== null && this.vListParams.length !== 0) {
            return this.vListParams[this.vListParams.length - 1];
        }
        else return null;
    }

    popParam() {
        if (this.vListParams.length > 0) {
            this.vListParams.pop();
        }
    }

    gotoPreviousPage() {
        this.navigate([this.getPreviousPage()]);       
    }

    getUrlParameter(name, url) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),results = regex.exec(url);
        if (!results) 
            return null;
        if (!results[2]) 
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    navigate(pPage: any) {
        this._router.navigate(pPage);
    }

    getListParams() {
        return this.vListParams;
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/page-navigation.service.ts